import * as tslib_1 from "tslib";
// win flash this is located in flash.trace.Trace, but i didnt want to create a new folder just for it, so i put it into utils
var Trace = (function (_super) {
    tslib_1.__extends(Trace, _super);
    function Trace() {
        return _super.apply(this, arguments) || this;
    }
    Trace.getLevel = function (target) {
        if (target === void 0) { target = 2; }
        console.log("getLevel is not implemented yet in flash/Trace");
        return 0;
    };
    Trace.getListener = function () {
        console.log("getListener is not implemented yet in flash/Trace");
        return null;
    };
    Trace.setLevel = function (l, target) {
        if (target === void 0) { target = 2; }
        console.log("setLevel is not implemented yet in flash/Trace");
    };
    Trace.setListener = function (f) {
        console.log("setListener is not implemented yet in flash/Trace");
    };
    return Trace;
}(Object));
export { Trace };
